import React from "react";
import ArrowBack from "@mui/icons-material/ArrowBack";
import Close from "@mui/icons-material/Close";

import { IconContainer, IconContainerProps } from "./HeaderNavigation.styles";

export interface HeaderNavigationParams extends IconContainerProps {
  onClick?(): void;
  hide?: boolean;
  type?: "arrow" | "close";
}

export const HeaderNavigation: React.FC<HeaderNavigationParams> = ({
  onClick,
  hide,
  marginTop,
  type = "arrow",
}) => {
  if (hide) {
    return <React.Fragment />;
  }

  return (
    <IconContainer onClick={onClick} marginTop={marginTop}>
      {type === "arrow" ? (
        <ArrowBack style={{ color: "#030096" }} />
      ) : (
        <Close style={{ color: "#030096" }} />
      )}
    </IconContainer>
  );
};
